import React from "react";
import BillingReconciliationPage from "./BillingReconciliationPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface BillingReconciliationPageContainerProps extends RouteProps, withValidUserRoleProps {}

const BillingReconciliationPageContainer = (props: BillingReconciliationPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <BillingReconciliationPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(BillingReconciliationPageContainer);
